// FotoVariacionCard — P3-9b. Tarjeta de la foto de una variación. Extraída para
// testear que la etiqueta de optimización va SOBRE la imagen (en `.pp-varimg-foto`)
// y no en el pie de la tarjeta (`.pp-varimg-info`, donde está el botón «Cambiar»).
import React from 'react';
import Button from './ui/Button';
import MarcaOptimizacion from './MarcaOptimizacion';

export default function FotoVariacionCard({ etiqueta, src, alt, distintivo = null, onCambiar, onUsarPrincipal }) {
  return (
    <div className="pp-varimg">
      <div className="pp-varimg-foto" data-testid="foto-variacion-img">
        {src
          ? <img src={src} alt={alt} />
          : <div className="pp-varimg-empty" title="Sin imagen">Sin imagen</div>}
        {src && distintivo && <MarcaOptimizacion distintivo={distintivo} />}
      </div>
      <div className="pp-varimg-info" data-testid="foto-variacion-pie">
        <span>{etiqueta}</span>
        {!src && <small className="pp-warn">Sin imagen: Google marca error en la ficha.</small>}
        <div className="pp-varimg-actions">
          <Button size="sm" onClick={onCambiar}>Cambiar</Button>
          {!src && <Button size="sm" onClick={onUsarPrincipal}>Usar la principal</Button>}
        </div>
      </div>
    </div>
  );
}
